import React from 'react';

export const Summary = React.lazy(() => import('./Summary'));
export const ReportDashboard = React.lazy(() => import('./ReportDashboard'));
